<template>
  <span class="">
      <div v-if="busy" class="busy-container"><BusySpinner /></div>
      <div v-else class="container">
        <div class="sub-service">
          <p class="bold">
            📈Project Download Tracker
          </p>
          <p>
            Data is stored in Airtable (<a href="https://airtable.com/appkLRKXqDk1xaYhl/tblfiTmsEkgZEm0Na/viwqjPAFQ0vo1wiit?blocks=hide" target="_blank">link</a>)
          </p>
          <p>
            Documentation is in Notion (<a href="https://www.notion.so/alightcreative/Project-Download-Tracker-8777dd448bba4538ba90e96ae909260a" target="_blank">link</a>)
          </p>
          <form class="form">
            <button type="button" @click="fetchContent()">Sync data Airtable</button>
          </form>
          <div v-if="status" class="summary">
            <div class="status">
                {{ status }}
            </div>
            <div class="">
                {{ data }}
            </div>
          </div>
          <div v-if="error" class="summary">
             {{ error }}
          </div>
        </div>
      </div>

  </span>
</template>

<script>
import BusySpinner from '@/components/BusySpinner.vue'
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  name: "DownloadTracker",
  components: { BusySpinner },
  data: ()=>({
    busy: false,
    data: null,
    status: '',
    error: null
  }),
  methods: {
    fetchContent() {
      const curl = window.location.href
      if (curl.includes("localhost") || curl.includes("0.0.0.0")) {
          firebase.functions().useFunctionsEmulator("http://0.0.0.0:5001")
      }
      const endpoint = firebase.functions().httpsCallable('updateInterestedProjectList')
      this.busy = true
      endpoint().then((res) => {
        console.log(res.data)
        this.busy = false
        this.status = res.data.status
        this.error = null
      }).catch((error) => {
        this.busy = false
        this.error = error
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
.container {
  display: flex;
}
.busy-container {
  display: flex;
  justify-content: center;
}
.sub-service {
  border: 0.1em black solid;
  padding: 10px;
  border-radius: 5px;
}
.status {
  font-weight: bold;
}
.form {
  display: flex;
  justify-content: space-between;
  button {
    min-height: 80px;
    font-size: 12pt;
    width: 100%;
    cursor: pointer;
  } 
}
.summary {
  margin-top: 20px;
  padding-top: 5px;
  border-top: 1px black solid;
}
</style>
